/**
 * Utilitaires pour la génération d'identifiants uniques
 * 
 * @description Fonctions pour générer des IDs uniques pour le chat et autres composants
 * @since 2025-11-05
 */

/**
 * Génère un identifiant unique
 * @param prefix Préfixe optionnel pour l'ID
 * @returns Identifiant unique
 */
export function generateId(prefix?: string): string {
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 15);
  
  return prefix ? `${prefix}_${timestamp}_${randomPart}` : `${timestamp}_${randomPart}`;
}

/**
 * Génère un ID spécifique pour les messages de chat
 */
export function generateMessageId(): string {
  return generateId('msg');
}

/**
 * Génère un ID spécifique pour les conversations
 */
export function generateConversationId(): string {
  return generateId('conv');
}

/**
 * Génère un ID de session unique
 */
export function generateSessionId(): string {
  return generateId('session');
}

/**
 * Valide qu'un ID a le bon format
 */
export function isValidId(id: string): boolean {
  if (!id || typeof id !== 'string') return false;
  
  // Format: [prefix_]timestamp_random
  const parts = id.split('_');
  return parts.length >= 2 && parts.every(part => part.length > 0);
}